import React from "react";
import "./styles.css";

interface DateTimeInputProps {
    value?: string | null;
    onChange?: (value: string) => void;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
    "aria-label"?: string;
}

const hours = Array.from({ length: 24 }, (_, index) => String(index).padStart(2, "0"));
const minutes = Array.from({ length: 60 }, (_, index) => String(index).padStart(2, "0"));

const DateTimeInput: React.FC<DateTimeInputProps> = ({
    value,
    onChange,
    disabled = false,
    readOnly = false,
    className = "",
    "aria-label": label = "Datum a čas"
}) => {
    const [date = "", time = ""] = (value ?? "").split("T");
    const [hour = "00", minute = "00"] = time ? time.split(":") : [];
    const partClassName = `date-time-input__part ${className}`;

    if (readOnly) {
        const [year, month, day] = date.split("-");
        return <input className={className} type="text" readOnly disabled={disabled}
            aria-label={label} value={date ? `${day}.${month}.${year} ${hour}:${minute}` : ""} />;
    }

    return (
        <span className="date-time-input" role="group" aria-label={label}>
            <input type="date" className={partClassName} value={date} disabled={disabled}
                aria-label={`${label} – datum`}
                onChange={event => onChange?.(event.target.value ? `${event.target.value}T${hour}:${minute}` : "")} />
            <select className={partClassName} value={date ? hour : ""} disabled={disabled || !date}
                aria-label={`${label} – hodiny (00–23)`}
                onChange={event => onChange?.(`${date}T${event.target.value}:${minute}`)}>
                <option value="" disabled>HH</option>
                {hours.map(value => <option key={value} value={value}>{value}</option>)}
            </select>
            <span className="date-time-input__separator" aria-hidden="true">:</span>
            <select className={partClassName} value={date ? minute : ""} disabled={disabled || !date}
                aria-label={`${label} – minuty (00–59)`}
                onChange={event => onChange?.(`${date}T${hour}:${event.target.value}`)}>
                <option value="" disabled>mm</option>
                {minutes.map(value => <option key={value} value={value}>{value}</option>)}
            </select>
        </span>
    );
};

export default DateTimeInput;
